document.addEventListener('DOMContentLoaded', function() {
    // Get all tab buttons and panels
    const tabButtons = document.querySelectorAll('.gh-article-tab');
    const tabPanels = document.querySelectorAll('.gh-article-categories-panel');

    // Function to switch tabs
    function switchTab(oldTab, newTab) {
        oldTab.classList.remove('active');
        newTab.classList.add('active');

        const targetId = newTab.getAttribute('data-tab');
        const targetPanel = document.querySelector(`#${targetId}`);

        // Hide all panels
        tabPanels.forEach(panel => {
            panel.classList.remove('active');
        });

        // Show target panel
        if (targetPanel) {
            targetPanel.classList.add('active');
        }
    }

    // Add click event listeners to all tab buttons
    tabButtons.forEach(tab => {
        tab.addEventListener('click', (e) => {
            e.preventDefault();
            const currentTab = document.querySelector('.gh-article-tab.active');
            if (currentTab !== tab) {
                switchTab(currentTab, tab);
            }
        });
    });

    // Set first tab as active by default
    if (tabButtons.length > 0 && tabPanels.length > 0) {
        tabButtons[0].classList.add('active');
        tabPanels[0].classList.add('active');
    }
});